// extracted by mini-css-extract-plugin
export var article__meta = "article-module--article__meta--3ZN9Y";
export var article__tax = "article-module--article__tax--19WVe";
export var article = "article-module--article--3krkC";
export var featimg = "article-module--featimg--3ZzOg";
export var article__title = "article-module--article__title--260Dh";
export var article__content = "article-module--article__content--1lwtL";